import * as React from 'react';
import styled from 'styled-components';

const OneCol: React.FunctionComponent = styled.div`
   grid-column: 2/span 12;
`;

export default OneCol;